// extracted by mini-css-extract-plugin
export default {"rating":"CD-z","numberOfStars":"DD-z","count":"ED-z","barGraphSpacing":"FD-z","barGraph":"GD-z"};